import { AbstractControl } from '@angular/forms';

export function BudgetKostnaderRequired(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const anyNonZero = parsedValue.some((pv) => pv.value && pv.value > 0);
    if (anyNonZero) {
      return;
    }
  }

  return { BudgetKostnaderRequired: true };
}

export function SkissBudgetKostnaderRequired(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const anyNonZero = parsedValue.some((pv) => pv.value && pv.value > 0);
    if (anyNonZero) {
      return;
    }
  }

  return { SkissBudgetKostnaderRequired: true };
}
